import { getEventType, getSystemPath } from '@/utils/helper'
import { translate } from '@/utils/translate'

export default {
  install (app) {
    // Add translate globally
    app.config.globalProperties.$translate = translate

    app.config.globalProperties.$eventType = getEventType

    // Add getSystemPaths globally
    app.config.globalProperties.$systemPath = getSystemPath
  }
}
